<template>
  <div>
    <hi-dialog
      v-show="!showCustomModal"
      class="repeat-dialog"
      title="Repeat"
      @close="close"
    >
      <div class="repeat-form">
        <div class="form-group">
          <hi-form-item type="header" title="Time"></hi-form-item>
          <hi-form-item :readonly="true" title="Start Time">{{
            startTimeText
          }}</hi-form-item>
          <hi-form-item title="End Time">
            <hi-datetime
              :pickerOptions="endDateOption"
              type="date"
              :clearAble="false"
              v-model="endDate"
            ></hi-datetime>
          </hi-form-item>
        </div>
        <div class="form-group">
          <hi-form-item type="header" title="Repeat"></hi-form-item>
          <hi-form-item
            type="select"
            :model="type === 'never'"
            title="Never"
            @click.native="changeType('never')"
          ></hi-form-item>
          <hi-form-item
            type="select"
            :model="type === 'hour'"
            title="Every 12 Hours"
            @click.native="changeType('hour')"
          ></hi-form-item>
          <hi-form-item
            type="select"
            :model="generalAll"
            title="Every Day"
            @click.native="selectGeneralAll(null)"
          ></hi-form-item>
          <hi-form-item
            type="select"
            :key="r.value"
            v-for="r in general.repeat"
            :model="r.select"
            :title="r.text"
            @click.native="changeGeneralWeek(r)"
          ></hi-form-item>
          <hi-form-item
            type="select"
            :model="type === 'custom'"
            :clickAble="true"
            title="Custom"
            @click.native="changeType('custom')"
          ></hi-form-item>
        </div>
      </div>
    </hi-dialog>
    <hi-dialog
      v-if="showCustomModal"
      class="repeat-dialog custom-dialog"
      title="Repeat"
      @close="close"
    >
      <img
        @click="showCustomModal = false"
        class="back-icon"
        slot="left"
        src="../../../../../../public/images/common/Back@3x.png"
      />
      <div>
        <div class="form-group">
          <hi-form-item title="Frequency" :click-able="true">
            <el-select v-model="custom.type">
              <el-option
                v-for="item in custom.repeatCustomType"
                :key="item.key"
                :label="item.text"
                :value="item.key"
              ></el-option>
            </el-select>
          </hi-form-item>
          <!--daily-->
          <template v-if="custom.type === 'daily'">
            <hi-form-item
              title="Every"
              :tipMessage="customDailyTip"
              :click-able="true"
            >
              <el-select v-model="custom.daily.selected">
                <el-option
                  v-for="item in customDailySelectList"
                  :key="item.key"
                  :label="item.text"
                  :value="item.key"
                ></el-option>
              </el-select>
            </hi-form-item>
          </template>
          <template v-if="custom.type === 'weekly'">
            <hi-form-item
              title="Every"
              :tipMessage="customWeekTip"
              :click-able="true"
            >
              <el-select v-model="custom.weekly.interval">
                <el-option
                  v-for="item in customWeekSelectList"
                  :key="item.key"
                  :label="item.text"
                  :value="item.key"
                ></el-option>
              </el-select>
            </hi-form-item>
          </template>
          <template v-if="custom.type === 'monthly'">
            <hi-form-item
              title="Every"
              model="Month"
              :tipMessage="customMonthTip"
              :click-able="true"
            >
            </hi-form-item>
          </template>
        </div>
        <div
          class="custom-bottom-container"
          :class="{ 'bottom-line': custom.type === 'weekly' }"
        >
          <div v-if="custom.type === 'weekly'">
            <hi-form-item
              padding-l-r="0"
              type="header"
              title="Repeat"
            ></hi-form-item>
            <hi-form-item
              padding-l-r="0"
              type="select"
              :key="w.key"
              v-for="w in customWeekMenu"
              :model="w.select"
              :title="w.text"
              @click.native="selectCustomWeekly(w)"
            ></hi-form-item>
          </div>
          <template v-if="custom.type === 'monthly'">
            <hi-form-item
              padding-l-r="0"
              type="header"
              title="Repeat"
            ></hi-form-item>
            <hi-form-item
              padding-l-r="0"
              class="bottom-line"
              type="select"
              :model="custom.monthly.type === 'each'"
              title="Each"
              @click.native="selectCustomMonthly('each')"
            ></hi-form-item>
            <hi-form-item
              padding-l-r="0"
              type="select"
              :class="{ 'bottom-line': custom.monthly.type === 'on' }"
              :model="custom.monthly.type === 'on'"
              title="On the ..."
              @click.native="selectCustomMonthly('on')"
            ></hi-form-item>
          </template>
        </div>
        <template
          v-if="custom.type === 'monthly' && custom.monthly.type === 'each'"
        >
          <calender v-model="custom.monthly.eachSelected"></calender>
        </template>
        <template
          v-if="custom.type === 'monthly' && custom.monthly.type === 'on'"
        >
          <div class="form-group">
            <hi-form-item class="custom-on" :click-able="true">
              <el-select v-model="custom.monthly.on.interval">
                <el-option
                  v-for="item in custom.monthly.onIntervalList"
                  :key="item.key"
                  :label="item.text"
                  :value="item.key"
                ></el-option>
              </el-select>
            </hi-form-item>
            <hi-form-item class="custom-on" :click-able="true">
              <el-select v-model="custom.monthly.on.week">
                <el-option
                  v-for="item in onWeekTypes"
                  :key="item.key"
                  :label="item.singleText"
                  :value="item.key"
                ></el-option>
              </el-select>
            </hi-form-item>
          </div>
        </template>
      </div>
    </hi-dialog>
  </div>
</template>
<style lang="less">
.repeat-dialog {
  height: 730px;
  .hi-form-item {
    .right-container {
      width: 100px;
      flex: none;
    }
    .left-container {
      flex: 1;
    }
    &.custom-on {
      .right-container {
        flex: 1;
        width: auto;
        margin-left: 0;
        .el-input input {
          text-align: left !important;
          color: black;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
@import "../../../../../assets/style/theme";

.bottom-line {
  border-bottom: 1px solid #e6e6e6 !important;
}

.repeat-dialog {
  width: 375px;
  margin-left: 5px;
  display: flex;
  flex-direction: column;

  .hi-form-item {
    border-bottom-width: 0;
  }

  .form-group {
    border-bottom: 1px solid #e6e6e6;

    &.top {
      border-top: 1px solid #e6e6e6;
      border-bottom-width: 0;
    }
  }

  .custom-bottom-container {
    padding-left: 20px;
  }

  .back-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  .repeat-form {
    flex: 1;
    overflow: auto;

    .form-item {
      height: 44px;
      display: flex;
      padding: 0 20px;
      align-items: center;
      justify-content: space-between;

      .title {
        font-size: 16px;
      }

      .content {
        font-size: 14px;
        color: #5a5a5a;
        flex: 1;
        text-align: right;
      }

      .select-icon {
        width: 16px;
        height: 16px;
        background-size: contain;
        background-image: url("../../../../../../public/images/setting/select_2@3x.png");
      }

      &.select {
        cursor: pointer;

        &:hover,
        &:active {
          opacity: 0.7;
        }
      }
    }
  }
}
</style>

<script>
import hiDialog from "../../../../common/dialog/Index.vue";
import hiDatetime from "../../../../common/form/DateTime";
import moment from "moment-timezone";
import hiFormItem from "../../../../common/form/Index.vue";
import calender from "../repeat/MonthlyCalendar";
import { repeatCustomType } from "../../../../../const/schedule";
import { weekType } from "../../../../../const/setting";
import _ from "lodash";

export default {
  name: "CalenderScheduleRepeatComponent",
  components: { hiDialog, hiDatetime, hiFormItem, calender },
  props: {
    form: {
      type: Object,
    },
  },
  computed: {
    startTimeText() {
      return moment(this.form.postTime).format("MMM DD, YYYY");
    },
    /**
     * 计算是否选中所有
     */
    generalAll() {
      const all = this.general.repeat.findIndex((r) => !r.select) === -1;
      return all;
    },
    /**
     * 计算custom daily 的every 文案
     */
    customDailyTip() {
      const dayNum = this.custom.daily.selected;
      if (dayNum === 1) {
        return `Event will occur every day.`;
      } else {
        return `Event will occur every ${dayNum} days.`;
      }
    },
    /**
     *  计算custom daily的选项
     */
    customDailySelectList() {
      const list = [];
      for (let i = 1; i <= 31; i++) {
        const day = {
          key: i,
          text: `${i} day`,
        };
        if (i > 1) {
          day.text = `${i} days`;
        }
        list.push(day);
      }
      return list;
    },
    /**
     * 计算custom week 的every 文案
     */
    customWeekTip() {
      const dayNum = this.custom.weekly.interval;
      let weekText = "";
      const weekArr = this.custom.weekly.selected.map((r) => {
        return weekType.find((w) => w.key === r).singleText;
      });
      if (weekArr.length === 2) {
        weekText = weekArr.join(" and ");
      } else {
        weekText = weekArr.join(", ");
      }
      if (dayNum === 1) {
        return `Event will occur every week on ${weekText}.`;
      } else {
        return `Event will occur every ${dayNum} weeks on ${weekText}.`;
      }
    },
    /**
     *  计算custom week的选项
     */
    customWeekSelectList() {
      const list = [];
      for (let i = 1; i <= 5; i++) {
        const week = {
          key: i,
          text: `${i} week`,
        };
        if (i > 1) {
          week.text = `${i} weeks`;
        }
        list.push(week);
      }
      return list;
    },
    /**
     * 计算custom week模式菜单
     */
    customWeekMenu() {
      return weekType.map((w) => {
        return {
          key: w.key,
          text: w.singleText,
          select: this.custom.weekly.selected.includes(w.key),
        };
      });
    },
    /**
     * 计算custom month 的every 文案
     */
    customMonthTip() {
      if (this.custom.monthly.type === "each") {
        const dayArr = _.cloneDeep(this.custom.monthly.eachSelected)
          .sort((s1, s2) => (s1 > s2 ? 1 : -1))
          .map((e) => {
            const ending = e % 10;
            if (ending === 1) {
              return `${e}st`;
            } else if (e === 2) {
              return `${e}nd`;
            } else if (e === 3) {
              return `${e}rd`;
            } else {
              return `${e}th`;
            }
          });
        let dayText = "";
        if (dayArr.length === 2) {
          dayText = dayArr.join(" and ");
        } else {
          dayText = dayArr.join(", ");
        }
        return `Event will occur every month on the ${dayText}.`;
      } else if (this.custom.monthly.type === "on") {
        const onIntervalText = this.custom.monthly.onIntervalList.find(
          (i) => i.key === this.custom.monthly.on.interval
        ).abbreviation;
        const weekText = this.onWeekTypes.find(
          (i) => i.key === this.custom.monthly.on.week
        ).singleText;
        return `Event will occur every month on the ${onIntervalText} ${weekText}.`;
      }
    },
    onWeekTypes() {
      return [
        ...weekType,
        {
          key: -1,
          singleText: "Day",
        },
        {
          key: -2,
          singleText: "Weekday",
        },
        {
          key: -3,
          singleText: "Weekend day",
        },
      ];
    },
  },
  watch: {
    "form.postTime": {
      handler(val) {
        // end time永远是 post time 加一天
        this.endDate = moment(val).add(1, "d").format("YYYY-MM-DD");
      },
      immediate: true,
    },
    /**
     * 监听type变化，动态想外传递变更文案
     */
    type: {
      handler(val) {
        if (val === "never") {
          this.$emit("update:type", "Never");
        } else if (val === "hour") {
          this.$emit("update:type", "Every 12 Hours");
        } else if (val === "custom") {
          this.$emit("update:type", "Custom");
        }
      },
      immediate: true,
    },
    "general.repeat": {
      handler(val) {
        // 获取所有选中日期
        const selectList = val.filter((v) => v.select).map((v) => v.value);
        if (selectList.length === 7) {
          this.$emit("update:type", "Every Day");
        } else if (selectList.length > 0) {
          const weeks = weekType
            .filter((w) => selectList.includes(w.key))
            .map((w) => w.abbreviation);
          this.$emit("update:type", weeks.join(" "));
        }
      },
      deep: true,
    },
  },
  methods: {
    close() {
      this.$parent.showRepeatTime = false;
    },
    /**
     * 改变repeat 类型
     */
    changeType(type) {
      this.selectGeneralAll(false);
      this.type = type;
      if (type === "custom") {
        this.showCustomModal = true;
      }
    },
    /**
     * 改变普通repeat 周选中
     */
    changeGeneralWeek(r) {
      this.type = "general";
      r.select = !r.select;
    },
    /**
     * 自定义模式选中日期
     */
    selectCustomWeekly(r) {
      // 获取是否已选中
      const selectIndex = this.custom.weekly.selected.findIndex(
        (s) => s === r.key
      );
      // 未选中则添加到选中列表
      if (selectIndex === -1) {
        this.custom.weekly.selected.push(r.key);
      } else {
        if (this.custom.weekly.selected.length !== 1) {
          // 未选中则删除选中项
          this.custom.weekly.selected.splice(selectIndex, 1);
        }
      }
    },
    /**
     * 切换定义月类型
     */
    selectCustomMonthly(type) {
      this.custom.monthly.type = type;
    },
    /**
     * every day 点击事件
     */
    selectGeneralAll(select) {
      this.type = "general";
      let state = select;
      if (state === null) {
        state = !this.generalAll;
      }
      // 如果发现是全不选，则自动勾选Never
      if (!state) {
        this.type = "never";
      }
      // 如果全选则点击全不选，如果存在一项未选择则点击后全选
      this.general.repeat.forEach((r) => {
        r.select = state;
      });
    },
    /**
     * 获取所有发布时间
     */
    getTimes() {
      // 获取开始时间和结束是时间
      const startDate = moment(this.form.postTime);
      const endDate = moment(`${this.endDate} 23:59`);
      let postTimes = [startDate];
      /**
       * 固定时间间隔发送
       * @param num 间隔
       * @param type 单位
       */
      const intervalSend = ({ num = 12, type = "h" }) => {
        while (true) {
          const postTime = _.last(postTimes).clone().add(num, type);
          if (postTime.isBefore(endDate)) {
            postTimes.push(postTime);
          } else {
            break;
          }
        }
      };
      /**
       * 固定周几发送
       * @param interval 每隔几周发一次
       * @param weeks 每周那几天发送
       */
      const intervalWeekSend = ({ interval = 1, weeks = [0] }) => {
        while (true) {
          /**
           * 计算获取下一个发送周
           */
          let nextWeek;
          // 获取上次发送周
          let beforeWeekLast = _.last(postTimes).day();
          // 获取上次发送周在发送列表里的索引，如果找不到相同的则去找之后第一个周
          const beforeWeekIndex = weeks.findIndex((w) => w === beforeWeekLast);
          if (beforeWeekIndex !== -1) {
            // 如果上次发送周符合要求则切换到后一个，如果已经是最后一个则切换到下周重新计数
            if (beforeWeekIndex === weeks.length - 1) {
              // 最后一个
              nextWeek = _.first(weeks) + 7 * interval;
            } else {
              nextWeek = weeks[beforeWeekIndex + 1];
            }
          } else {
            // 如果没找到则则寻找之后最接近的周
            let nextWeekIndex = weeks.findIndex((w) => w >= beforeWeekLast);
            if (nextWeekIndex === -1) {
              // 发现当前周，比可选里最大周还大则重置到下周
              nextWeek = _.first(weeks) + 7 * interval;
            } else {
              nextWeek = weeks[nextWeekIndex];
            }
          }
          const postTime = _.last(postTimes).clone().days(nextWeek);
          if (postTime.isBefore(endDate)) {
            postTimes.push(postTime);
          } else {
            // 同时发现如果第一个时间不符合要求则删除第一个
            if (!weeks.find((w) => w === _.first(postTimes).day())) {
              postTimes.splice(0, 1);
            }
            break;
          }
        }
      };
      // 没设置时间返回空数组
      if (this.type === "never") {
        return null;
      } else if (this.type === "general") {
        // 获取需要送周列表
        const weeks = this.general.repeat
          .filter((r) => r.select)
          .map((r) => r.value);
        intervalWeekSend({ weeks });
      } else if (this.type === "hour") {
        intervalSend({ num: 12, type: "h" });
      } else if (this.type === "custom" && this.custom.type === "daily") {
        intervalSend({ num: this.custom.daily.selected, type: "d" });
      } else if (this.type === "custom" && this.custom.type === "weekly") {
        // 对选中日期进行排序
        const weeks = this.custom.weekly.selected.sort((s1, s2) =>
          s1 > s2 ? 1 : -1
        );
        intervalWeekSend({ weeks, interval: this.custom.weekly.interval });
      } else if (
        this.type === "custom" &&
        this.custom.type === "monthly" &&
        this.custom.monthly.type === "each"
      ) {
        postTimes = [];
        // 重新排序一下
        const dates = _.cloneDeep(this.custom.monthly.eachSelected).sort(
          (s1, s2) => (s1 > s2 ? 1 : -1)
        );
        // 计算开始和结束的月差 Math.ceil 整数向上取证
        const monthDiff = Math.ceil(endDate.diff(startDate, "months", true));
        const dateList = [];
        for (let i = 0; i <= monthDiff; i++) {
          const currentMonth = startDate.clone().add(i, "M");
          dates.forEach((d) => {
            let day = d;
            if (day < 10) {
              day = `0${d}`;
            }
            dateList.push(currentMonth.format(`YYYY-MM-${day} HH:mm`));
          });
        }
        dateList.forEach((day) => {
          const datetime = moment(day);
          // 日期必须合法
          if (datetime.isValid()) {
            // 日期必须介于开始和结束时间之间
            if (
              !datetime.isBefore(startDate, "day") &&
              !datetime.isAfter(endDate, "day")
            ) {
              postTimes.push(datetime);
            }
          }
        });
      } else if (
        this.type === "custom" &&
        this.custom.type === "monthly" &&
        this.custom.monthly.type === "on"
      ) {
        postTimes = [];
        // 暂存日期的数组
        const dateList = [];
        // 计算开始和结束的月差 Math.ceil 整数向上取证
        const monthDiff = Math.ceil(endDate.diff(startDate, "months", true));
        for (let i = 0; i <= monthDiff; i++) {
          const currentMonth = startDate.clone().date(1).add(i, "M");
          const interval = this.custom.monthly.on.interval;
          const week = this.custom.monthly.on.week;
          // 获取当前月符合周的日期(每月最多5周)
          const currentMonthList = [];
          if (week >= 0) {
            for (let k = 0; k <= 5; k++) {
              const datetime = currentMonth.clone().day(week + 7 * k);
              // 必须要在当月内
              if (currentMonth.format("MM") === datetime.format("MM")) {
                currentMonthList.push(datetime);
              }
            }
          } else {
            let datetime = currentMonth.clone();
            while (true) {
              if (datetime.format("MM") !== currentMonth.format("MM")) {
                break;
              }
              // 每天
              if (week === -1) {
                currentMonthList.push(datetime.clone());
              }
              // 工作日
              if (week === -2) {
                if (datetime.days() !== 0 && datetime.days() !== 6) {
                  currentMonthList.push(datetime.clone());
                }
              }
              // 休息日
              if (week === -3) {
                if (datetime.days() === 0 || datetime.days() === 6) {
                  currentMonthList.push(datetime.clone());
                }
              }
              datetime.add(1, "d");
            }
          }
          if (interval === -1) {
            dateList.push(currentMonthList[currentMonthList.length - 1]);
          } else {
            // 同时获取符合条件周x的指定位置
            const datetime = currentMonthList[interval];
            if (datetime) {
              dateList.push(datetime);
            }
          }
        }
        // 日期必须介于开始和结束时间之间
        dateList.forEach((datetime) => {
          if (
            !datetime.isBefore(startDate, "day") &&
            !datetime.isAfter(endDate, "day")
          ) {
            postTimes.push(datetime);
          }
        });
      }
      let delInterval = null;
      // 計算刪除時間間隔
      if (this.form.deleteTime) {
        delInterval = moment(this.form.deleteTime, "YYYY-MM-DD HH:mm").diff(
          moment(this.form.postTime, "YYYY-MM-DD HH:mm"),
          "m"
        );
      }
      const result = postTimes.map((t) => {
        return {
          postTime: t.format("YYYY-MM-DD HH:mm"),
          deleteTime: delInterval
            ? moment(t).add(delInterval, "m").format("YYYY-MM-DD HH:mm")
            : "",
        };
      });
      return result;
    },
  },
  data() {
    const _this = this;
    return {
      endDateOption: {
        disabledDate(time) {
          const startDate = moment(_this.form.postTime).add(-1, "d");
          const limitEndDate = moment(_this.form.postTime).add(3, "M");
          if (
            moment(time).isBefore(limitEndDate) &&
            moment(time).isAfter(startDate)
          ) {
            return false;
          } else {
            return true;
          }
        },
      },
      showCustomModal: false,
      endDate: "",
      type: "never",
      weekType,
      general: {
        repeat: [
          {
            text: "Every Sunday",
            value: 0,
            select: false,
          },
          {
            text: "Every Monday",
            value: 1,
            select: false,
          },
          {
            text: "Every Tuesday",
            value: 2,
            select: false,
          },
          {
            text: "Every Wednesday",
            value: 3,
            select: false,
          },
          {
            text: "Every Thursday",
            value: 4,
            select: false,
          },
          {
            text: "Every Friday",
            value: 5,
            select: false,
          },
          {
            text: "Every Saturday",
            value: 6,
            select: false,
          },
        ],
      },
      custom: {
        repeatCustomType,
        // daily weekly monthly
        type: "daily",
        daily: {
          selected: 1,
        },
        weekly: {
          interval: 1,
          selected: [0],
        },
        monthly: {
          // each(each) ,on(on the)
          type: "each",
          eachSelected: [1],
          onIntervalList: [
            { key: 0, text: "First", abbreviation: "1st" },
            { key: 1, text: "Second", abbreviation: "2nd" },
            { key: 2, text: "Third", abbreviation: "3rd" },
            { key: 3, text: "Fourth", abbreviation: "4th" },
            { key: 4, text: "Fifth", abbreviation: "5th" },
            { key: -1, text: "Last", abbreviation: "last" },
          ],
          on: {
            interval: 0, // 间隔 -1代表最后一周
            week: 0, // 重复的星期
          },
        },
      },
    };
  },
  created() {
    const currentDateTime = moment().tz(this.form.tzName);
    // weekly模式默认选择当前日期
    const currentDays = currentDateTime.days();
    this.custom.weekly.selected = [currentDays];
    // monthly模式默认选择当前日期
    const currentDate = currentDateTime.date();
    this.custom.monthly.eachSelected = [currentDate];
  },
};
</script>
